// src/firebase.js
import firebase from 'firebase/app'
import 'firebase/messaging' // importa solo messaging

// 🔑 Configurazione che trovi su Firebase Console → Web app
const firebaseConfig = {
  apiKey: 'AIzaSyBRlVDAzgXCZ6CWeaN24bPT5r0e1nED2Ro',
  authDomain: 'luci-mobile.firebaseapp.com',
  projectId: 'luci-mobile',
  storageBucket: 'luci-mobile.appspot.com',
  messagingSenderId: '879921301477',
  appId: '1:879921301477:ios:aa32e7a2f68233934b110c'
}

// Inizializza Firebase
firebase.initializeApp(firebaseConfig)

// Inizializza Messaging
let messaging
try {
  messaging = firebase.messaging()
} catch (e) {
  console.warn('⚠️ Firebase Messaging non disponibile:', e)
}

// Funzione per ottenere il token
export async function getTokenFCM () {
  try {
    // Sincronizza il codice con la registrazione del service worker.
    // Il metodo .ready() assicura che il service worker sia installato e attivo.
    if ('serviceWorker' in navigator) {
      console.log('firebase.js: start registration')
      // 1. Registra il service worker
      await navigator.serviceWorker.register('/firebase-messaging-sw.js')
      console.log('firebase.js: registration complete')
      // 2. Attendi che il service worker sia pronto
      await navigator.serviceWorker.ready
      console.log('firebase.js: service worker ready')
    }

    const currentToken = await messaging.getToken({
      vapidKey: 'BFIthycktTxdPM67I_9-JU_hC2bDk7fWh-Dl05QCQ43u4GWsZUGFu7jqs30n7g9YYCEz_C-Z19tMolcyiM1P12s' // dalla console Firebase Web Push
    })
    if (currentToken) return currentToken
    return null
  } catch (err) {
    console.error('Errore nel recupero token FCM:', err)
    return null
  }
}

export { firebase, messaging }



// WEBPACK FOOTER //
// ./src/firebase.js